var chunkMapping = {
	"19": [
		4019
	],
	"35": [
		35
	],
	"76": [
		76
	],
	"95": [
		1095
	],
	"96": [
		2096
	],
	"107": [
		8107
	],
	"136": [
		9136
	],
	"153": [
		5153
	],
	"227": [
		8227
	],
	"249": [
		4249
	],
	"260": [
		4260
	],
	"291": [
		2291
	],
	"326": [
		3326
	],
	"346": [
		4346
	],
	"363": [
		5363
	],
	"390": [
		3390
	],
	"399": [
		9399
	],
	"431": [
		7431
	],
	"435": [
		435
	],
	"494": [
		4494
	],
	"498": [
		3498
	],
	"507": [
		2507
	],
	"548": [
		6548
	],
	"690": [
		2690
	],
	"729": [
		4729
	],
	"750": [
		5674
	],
	"781": [
		781
	],
	"796": [
		1796
	],
	"816": [
		1816
	],
	"897": [
		5897
	],
	"909": [
		909
	],
	"920": [
		8920
	],
	"933": [
		4933
	],
	"961": [
		961
	]
};
var idToExternalAndNameMapping = {
	"35": [
		"default",
		"./Swap",
		9018
	],
	"76": [
		"default",
		"./ChatCellSkeleton",
		9018
	],
	"435": [
		"default",
		"./Partner",
		2111
	],
	"781": [
		"default",
		"./OperationDateSkeleton",
		9018
	],
	"909": [
		"default",
		"./ButtonBannerSkeleton",
		9018
	],
	"961": [
		"default",
		"./OperationCellSkeleton",
		9018
	],
	"1095": [
		"default",
		"./ButtonSkeleton",
		9018
	],
	"1796": [
		"default",
		"./Slider",
		9018
	],
	"1816": [
		"default",
		"./ToggleButtons",
		9018
	],
	"2096": [
		"default",
		"./withPartner",
		2111
	],
	"2291": [
		"default",
		"./LocalizationDictionary",
		1602
	],
	"2507": [
		"default",
		"./InputOrdinarySkeleton",
		9018
	],
	"2690": [
		"default",
		"./SbpBlockSkeleton",
		4328
	],
	"3326": [
		"default",
		"./ButtonBanner",
		9018
	],
	"3390": [
		"default",
		"./BasicCellTitleSkeleton",
		9018
	],
	"3498": [
		"default",
		"./BasicCellNavigationSkeleton",
		9018
	],
	"4019": [
		"default",
		"./FavoritesButtonSkeleton",
		9018
	],
	"4249": [
		"default",
		"./Loader",
		9018
	],
	"4260": [
		"default",
		"./IntegrationHub",
		7910
	],
	"4346": [
		"default",
		"./ProductCellSkeleton",
		9018
	],
	"4494": [
		"default",
		"./InfoboxSkeleton",
		9018
	],
	"4729": [
		"default",
		"./Content",
		9018
	],
	"4933": [
		"default",
		"./NavBar",
		9018
	],
	"5153": [
		"default",
		"./BasicCellHeadlineSkeleton",
		9018
	],
	"5363": [
		"default",
		"./Layout",
		9018
	],
	"5674": [
		"default",
		"./hoc",
		9018
	],
	"5897": [
		"default",
		"./Tabs",
		9018
	],
	"6548": [
		"default",
		"./LoyaltyCardBannerSkeleton",
		9018
	],
	"7431": [
		"default",
		"./Row",
		9018
	],
	"8107": [
		"default",
		"./TabItemSkeleton",
		9018
	],
	"8227": [
		"default",
		"./ActionButtonSkeleton",
		9018
	],
	"8920": [
		"default",
		"./Button",
		9018
	],
	"9136": [
		"default",
		"./Skeleton",
		9018
	],
	"9399": [
		"default",
		"./Divider",
		9018
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}